/**
 * Identifying the tier is required to display Account user count exceed message
 * & Free tier welcome message
 */
export const FREE_TIER_ID = '61ef0a7db41a64a06400f1ed';
export const CUSTOM_TIER_ID = '61ef0a7db41a64a06400f1f5';
export const PREMIUM_TIER_ID = '61ef0a7db41a64a06400f204';

export const TRIAL_MAX_USER_COUNT = 10;
